var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"go-top-area"},[_c('div',{staticClass:"go-top-wrap"},[_c('div',{staticClass:"go-top-btn-wrap"},[_c('a',{staticClass:"go-top go-top-btn d-block",attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-angle-double-up"}),_c('i',{staticClass:"fa fa-angle-double-up"})])])])])
}]

export { render, staticRenderFns }